import { render, staticRenderFns } from "./DialogArticleDelete.vue?vue&type=template&id=5cc9b2b5&scoped=true"
import script from "./DialogArticleDelete.vue?vue&type=script&lang=js"
export * from "./DialogArticleDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9b2b5",
  null
  
)

export default component.exports